"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RowKeyedGridSelection = /** @class */ (function () {
    function RowKeyedGridSelection(selectionData) {
        this.selectionData = selectionData || {};
    }
    RowKeyedGridSelection.prototype.clearSelection = function () {
        this.selectionData = {};
    };
    RowKeyedGridSelection.prototype.isSelected = function (cell) {
        return !!cell.rowKey && this.selectionData[cell.rowKey];
    };
    RowKeyedGridSelection.prototype.toggleRowSelect = function (rowKey, select) {
        if (!rowKey) {
            throw new Error("rowKey must be defined");
        }
        if (select === null || select === undefined) {
            select = !this.selectionData[rowKey];
        }
        // wondering if we should `delete` in the !select case... --ckovatch
        this.selectionData[rowKey] = select;
    };
    return RowKeyedGridSelection;
}());
exports.RowKeyedGridSelection = RowKeyedGridSelection;
//# sourceMappingURL=RowKeyedGridSelection.js.map